import { Constantes } from "../constants/constantsGlobal";
import { iResponse } from "../models/interfaceResponse";

// Acceso sin contraseña: el backend valida la whitelist, genera el enlace
// (Admin SDK) y lo envía por el correo corporativo. Se llama antes del login,
// por eso no pasa por setupInterceptor (no hay token todavía).
export const sendEmailLinkService = async (
  email: string,
  continueUrl: string
): Promise<iResponse> => {
  const response = await fetch(Constantes.URI_SecurityEmailLinkSend, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, continue_url: continueUrl }),
  });
  if (!response.ok) {
    throw new Error(`Error en la solicitud: ${response.statusText}`);
  }
  const data: iResponse = await response.json();
  return data;
};
